import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/styles/style.css'
import './assets/styles/bootstrap.css'
import './assets/styles/global.css'
import './assets/ailFont/iconfont.css'

// import { BootstrapVue } from 'bootstrap'
//引入 vue-awesome-swiper 组件
import { swiper, swiperSlide } from 'vue-awesome-swiper';
// 引入 Swiper 的 CSS 样式
import 'swiper/css/swiper.css';




import VueQuillEditor from 'vue-quill-editor'
// require styles 导入样式 富文本
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)
Vue.use(ElementUI);


// 全局注册 swiper 和 swiperSlide 组件
Vue.component('swiper', swiper);
Vue.component('swiper-slide', swiperSlide);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
